import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import RankingsList from './RankingsList';

const RankingsSettingsPage: React.FC = () => {

    const pageHeader = {
        title: 'Ajustes de Rankings',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Rankings', href: menuRoutes.settings.path + menuRoutes.settings.rankings },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />

            <div className="p-6">
                <RankingsList />
            </div>
        </div>
    );
};

export default RankingsSettingsPage;